import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { v4 as uuidv4 } from 'uuid';

@Injectable({ providedIn: 'root' })
export class ChatApiService {

    constructor(private http: HttpClient) {}

    private refererHeaders(): { headers: HttpHeaders } {
        return {
            headers: new HttpHeaders({ 'X-Full-Referer': window.location.href })
        };
    }

    ensureUserChat(): string {
        let userChat = localStorage.getItem('user_chat');
        if (!userChat) {
            userChat = uuidv4();
            localStorage.setItem('user_chat', userChat);
        }
        return userChat;
    }

    getMessages(storeId: string, slickUid: string): Observable<any[]> {
        const url = `${environment.serverUrl}/public/admin/store/${storeId}/chat/${slickUid}/messages`;
        return this.http.get<any>(url, this.refererHeaders()).pipe(
            map(res => res?.messages ?? [])
        );
    }

    sendMessage(storeId: string, slickUid: string, payload: {
        content: string;
        username: string;
        user_chat: string;
    }): Observable<any> {
        const url = `${environment.serverUrl}/public/admin/store/${storeId}/chat/${slickUid}/messages`;
        return this.http.post<any>(url, payload, this.refererHeaders());
    }

    joinChat(storeId: string, slickUid: string, username: string, userChat: string): Observable<any> {
        const url = `${environment.serverUrl}/public/admin/store/${storeId}/chat/${slickUid}/join`;
        return this.http.post<any>(url, { username, user_chat: userChat }, this.refererHeaders());
    }
}
